const mbsIntro = () => {
    var clickEvent = (function() {
        if ('ontouchstart' in document.documentElement === true) {
            return 'touchstart';
    } else {
            return 'click';
        }
    })();
    var enabled = false;
    var abled = (window.innerWidth < 768) ? false : true ; // mbs-point-table 아코디언 pc, mo 구분

    function pointAcc(){
        var wrap = $(document).find('.mbs-point-table');
        var btn = wrap.find('.cell.cell-1');
        var screenOutHtml = '<span class="sr-only">open</span>';
        enabled = true;
        btn.each(function(){
            $(this).append(screenOutHtml);
        });

        btn.on(clickEvent, function(e){
            // console.log(e);
            var parent = $(this).parents('.rowgroup');
            var content = parent.find('.cell-2');
            var screenOut = $(this).find('.sr-only');
            e.preventDefault();
            if(parent.hasClass('open')){
                parent.removeClass('open');
                content.slideUp();
                screenOut.text('open');

            }else{
                parent.addClass('open');
                content.slideDown();
                screenOut.text('close');
            }
        });

    }

    $(document).ready(function(){

        var accBtn = $('.mbs-benefit-accordion .acc-btn');

        if($('body').hasClass('mobile')){
            pointAcc();
        }

        accBtn.on(clickEvent, function(e){
            e.preventDefault();
            var thisParent =  $(this).parents('.acc-box');
            var contents = thisParent.find('.acc-body');
            var screenOut = $(this).find('.sr-only');

            if(thisParent.hasClass('open')){
                contents.slideUp('slow');
                thisParent.removeClass('open');
                screenOut.text('open');
            }else{
                contents.slideDown('slow');
                thisParent.addClass('open');
                screenOut.text('close');
            }
        });
    });

    const mediaQuery = window.matchMedia('(max-width: 768px)');

    const mediaQueryHandler = function(e) {

        var wrap = $(document).find('.mbs-point-table');
        var cell =  wrap.find('.cell-2');
        var screenOut = wrap.find('.cell.cell-1 .sr-only');
        var rowgroup = wrap.find('.rowgroup');
        var windowW = window.innerWidth;

        if(e.matches){
            if(!enabled) pointAcc();
            if(abled){
                cell.css('display','none');  
                rowgroup.removeClass('open');
                abled = false; 
                var btn = wrap.find('.cell.cell-1');
                var screenOutHtml = '<span class="sr-only">open</span>';
                enabled = true;
                btn.each(function(){
                    $(this).append(screenOutHtml);
                });
            } 
        } else {
            if(screenOut){
                screenOut.remove();
            }

            rowgroup.removeClass('open');
            cell.css('display','table-cell');
            abled = true;
        }
    };

    mediaQuery.addEventListener('change', mediaQueryHandler);
    mediaQueryHandler(mediaQuery);

};

mbsIntro();